<div fxLayout="column" class="message-display-container">

  <ng-container *ngIf="isLoading then ShowLoading else ShowMessage"></ng-container>

  <ng-template #ShowLoading>
    <app-loading></app-loading>
  </ng-template>

  <ng-template #ShowMessage>
    <!-- Modern Centered Title -->
    <div class="message-header" fxLayout="column" fxLayoutAlign="center center">
      <div class="title-icon">
        <mat-icon>mail</mat-icon>
      </div>
      <h1 class="message-title">{{subject}}</h1>
      <div class="title-underline"></div>
    </div>

    <!-- Centered Content -->
    <div fxLayout="row" fxLayoutAlign="center center center" class="message-body">
      <div fxLayout="column" class="message-content">
        <quill-editor readOnly="readOnly" [modules]="{ toolbar: false }"
                      (onEditorCreated)="editorCreated($event, htmlContent)"
                      [styles]="editorStylePreview"></quill-editor>
      </div>
    </div>

    <!-- Back Button -->
    <div fxLayout="row" fxLayoutAlign="center center" style="margin-top: 30px;">
      <button mat-raised-button class="back-button" (click)="navigateBack()">
        <mat-icon>arrow_back</mat-icon>
        Πίσω
      </button>
    </div>

  </ng-template>
</div>
